import { createSlice } from '@reduxjs/toolkit';
import { getUserSchoolProperty } from '../../utils/utils';
import sectorLanguageTypes from '../../enums/sectorLanguageTypes';

const initialState = {
    lang: null,
    texts: {},
}

const translateSlice = createSlice({
    name: "translate",
    initialState,
    reducers: {
        initText(state, action) {
            state.texts = action.payload.texts;
        },
        initLang(state, action) {
            const { user, userDetails, currentLang } = action.payload;
            let lang = null;
            let storageKey = 'LANG';
            if (currentLang && (currentLang === 'he' || currentLang === 'ar')) {
                lang = currentLang;
                if (user?.exidentifier)
                    storageKey = `LANG-${user.exidentifier}`;
                try {
                    localStorage.setItem(storageKey, lang);
                }
                catch (error) {
                    console.error('Error saving lang to localStorage:', error);
                }
            }
            else if (user?.exidentifier) {
                storageKey = `LANG-${user.exidentifier}`;
                try {
                    lang = localStorage.getItem(storageKey);
                    if (!lang && userDetails) {
                        const sectorId = getUserSchoolProperty(userDetails, 'sectorId');
                        if (sectorId && sectorLanguageTypes[sectorId]) {
                            lang = sectorLanguageTypes[sectorId];
                            localStorage.setItem(storageKey, lang);
                        }
                    }
                }
                catch (error) {
                    console.error('Error reading from localStorage:', error);
                }
            }
            if (!lang) {
                lang = "he";
                try {
                    localStorage.setItem(storageKey, lang);
                } catch (error) {
                    console.error('Error saving default lang to localStorage:', error);
                }
            }

            state.lang = lang;
        }
    }
})

export const translateActions = translateSlice.actions;
export default translateSlice
